module.exports = __webpack_public_path__ + "static/datastructures-fe34ba39ff19e32ae01a7d2c8435b9f7.jpg";